import "dayjs/locale/sv";
import "dayjs/locale/fi";
import "dayjs/locale/da";
import "dayjs/locale/nn";
import "react-toastify/dist/ReactToastify.css";

import { Component } from "react";

import { Box } from "@adfenix/alexandria";
import GenericErrorPage from "components/GenericErrorPage";
import Sentry from "lib/sentry/init";
import { Sidebar } from "components/Sidebar";
import dayjs from "dayjs";
import i18n from "lib/i18n/init";
import { languageMap } from "utils/language";
import queryString from "query-string";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UiEvents from "components/UserTracking/UiEvents";
import { setConfiguration } from "react-grid-system";

const StyledBox = styled(Box)`
  height: 100%;
`;

setConfiguration({ gutterWidth: 32 });

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

class AppRoot extends Component {
  state = { error: false, loadingLanguage: true };

  static getDerivedStateFromError(error) {
    return { error: !!error };
  }

  async componentWillUnmount() {
    UiEvents.shutdown();
  }

  async componentDidMount() {
    const query = queryString.parse(global.location.search);
    const queryStringLanguage = query["language"];

    if (queryStringLanguage) {
      i18n.changeLanguage(queryStringLanguage);
      dayjs.locale(languageMap[queryStringLanguage] ?? "en");
    }

    toast.configure({
      autoClose: 3000,
      position: "top-center",
      toastClassName: "Toastify__toast--adfenix",
      bodyClassName: "Toastify__toast-body--centered",
      hideProgressBar: true,
      closeButton: false
    });
  }

  componentDidCatch(error, info) {
    Sentry.configureScope(scope => {
      scope.setExtras(info);
    });
    Sentry.captureException(error);
  }

  render() {
    if (this.state.error) {
      return <GenericErrorPage />;
    }

    return (
      <StyledBox display="flex" flexDirection="column">
        <Sidebar />

        <>{this.props.children}</>
      </StyledBox>
    );
  }
}

export default withRouter(AppRoot);
